module.exports = __webpack_public_path__ + "static/media/dheya2.a22dcbd1.png";